(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("jodit"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "jodit"], factory);
	else if(typeof exports === 'object')
		exports["JoditEditor"] = factory(require("react"), require("jodit"));
	else
		root["JoditEditor"] = factory(root["React"], root["jodit"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition